import { css } from 'styled-components'

export const BoxSizing = css`
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
  box-sizing: border-box;
`

export interface AriaAttributes {
  'aria-required': 'true' | 'false'
  'aria-labelledby': string
  'aria-errormessage'?: string
  'aria-describedby'?: string
  'aria-invalid': 'true' | 'false'
}

export function buildAriaAttributes(
  id: string,
  required: boolean,
  hasDescription: boolean,
  hasError: boolean,
  extraDescription?: string,
) {
  const ariaAttributes: AriaAttributes = {
    'aria-required': required ? 'true' : 'false',
    'aria-labelledby': id + '-label',
    'aria-invalid': hasError ? 'true' : 'false',
  }

  if (hasError) {
    ariaAttributes['aria-errormessage'] = `${id}-error`
  }
  if (hasDescription) {
    ariaAttributes['aria-describedby'] = `${id}-description`
  }

  if (extraDescription) {
    ariaAttributes['aria-describedby'] = `${
      ariaAttributes['aria-describedby'] ? ariaAttributes['aria-describedby'] + ' ' : ''
    }${extraDescription}`
  }
  return ariaAttributes
}
